import * as React from "react";
import styled from "styled-components";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Hero } from "./screens/home/hero";
import { Banner } from "./screens/home/banner";
import { PersonalDetails } from "./screens/home/personalDetails";
import { MyLists } from "./screens/home/myLists";
import { SpendType } from "./screens/home/spendType";
import { Welcome } from "./screens/home/welcome";
import { ShippingInfo } from "./screens/home/shippingInfo";
import { AboutUs } from "./screens/home/about";
import { Profile } from "./screens/profile/profile";
import { PrivacyPolicy } from "./screens/home/privacy"
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useEffect } from "react";
import { ScrollRestoration } from "react-router-dom";
import { Wall } from "./screens/home/elts"
import { AdminLogin } from "./screens/admin/AdminLogin";
import { AdminUsers } from "./screens/admin/AdminUsers";
import { ProductCatalog } from "./screens/admin/ProductCatalog";
import { PaymentManagement } from "./screens/admin/PaymentManagement";
import { OrderManagement } from "./screens/admin/OrderManagement";
import { InvoiceCreate } from "./screens/admin/InvoiceCreate";
import { InvoiceView } from "./screens/admin/InvoiceView";
import CronManagement from "./screens/admin/CronManagement";
import TimeoutAnalysis from "./screens/admin/TimeoutAnalysis";
import { GoogleSheetImports } from "./screens/admin/GoogleSheetImports";
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import Order from "./screens/order/Order";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* Allow content to define height while ensuring at least full viewport */
  min-height: 100vh;
  //overflow-y: auto;
  min-height: 0; /* Ensure flex children respect their min-height */
`;


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export function App() {
  return (
    <React.StrictMode>
      <GoogleOAuthProvider clientId="186531953354-llpaq06ifdj8il0d3g7unk1tgf2mh3ui.apps.googleusercontent.com">
        <SubscriptionProvider>
          <Router>
            <AppContainer>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Hero preventScrollReset={true} />} />
                <Route path="/elts" element={<Wall preventScrollReset={true} />} />
                <Route path="/banner" element={<Banner />} />
                <Route path="/personalDetails" element={<PersonalDetails preventScrollReset={true} />} />
                <Route path="/myLists" element={<MyLists />} />
                <Route path="/spendType" element={<SpendType />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/shippingInfo" element={<ShippingInfo />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/about" element={<AboutUs preventScrollReset={true} />} />
                <Route path="/brands" element={<PrivacyPolicy preventScrollReset={true} defaultSection="brands" />} />
                <Route path="/privacy" element={<PrivacyPolicy preventScrollReset={true} />} />
                <Route path="/order" element={<Order />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/products" element={<ProductCatalog />} />
                <Route path="/admin/payments" element={<PaymentManagement />} />
                <Route path="/admin/orders" element={<OrderManagement />} />
                <Route path="/admin/invoices/create" element={<InvoiceCreate />} />
                <Route path="/admin/invoices/view" element={<InvoiceView />} />
                <Route path="/admin/cron" element={<CronManagement />} />
                <Route path="/admin/google-sheets" element={<GoogleSheetImports />} />
                <Route path="/admin/timeouts" element={<TimeoutAnalysis />} />
              </Routes>
            </AppContainer>
          </Router>
        </SubscriptionProvider>
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
}
